import { ObservableMap } from 'mobx';
import type FileProviderViewState from '../store/schema/FileProviderViewState';
import { ProviderLoadStateOption } from '../store/schema/ProviderLoadStateOption';

export default function getDefaultFileProviderStore() {
    return {
        providers: new ObservableMap<string, FileProviderViewState>(),
        loadState: ProviderLoadStateOption.NotLoaded,
        removalPending: new ObservableMap<string, string>(),
    };
}
